export const ACTION_TYPES = {
  ANSWER_QUESTIONS_FROM_VIEW: 'answerQuestionsFromView',
  GET_POLL_SETTINGS: 'getPollSettings',
  GET_POLL_SHIPPING: 'getPollShipping',
  SEND_POLL: 'sendPoll',
  SET_EXTRA_DATA: 'setExtraData',
};
